module.exports = __webpack_public_path__ + "img/frame-4.f89238a0.svg";